import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "../components/ui/use-toast";

export default function useStopNotes() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Add or update notes for a stop
  const updateStopNotes = useCallback(async (stopId, notes) => {
    setLoading(true);
    setError(null);
    try {
      console.log(`Updating notes for stop ${stopId}...`);
      const response = await axios.post(`/notes/stops/${stopId}`, {
        notes
      });
      
      if (response.data) {
        console.log(`Notes updated for stop ${stopId}`);
        toast({
          title: 'Success',
          description: 'Notes updated successfully',
        });
        return response.data;
      }
      return null;
    } catch (err) {
      console.error(`Error updating notes for stop ${stopId}:`, err);
      const errorMessage = 
        err.response?.data?.error || 
        err.message || 
        'Failed to update notes.';
      setError(errorMessage);
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      });
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Get notes for a stop
  const getStopNotes = useCallback(async (stopId) => {
    setLoading(true);
    setError(null);
    try {
      console.log(`Getting notes for stop ${stopId}...`);
      const response = await axios.get(`/notes/stops/${stopId}`);
      
      if (response.data) {
        console.log(`Notes retrieved for stop ${stopId}`);
        return response.data;
      }
      return null;
    } catch (err) {
      console.error(`Error getting notes for stop ${stopId}:`, err);
      const errorMessage = 
        err.response?.data?.error || 
        err.message || 
        'Failed to get notes.';
      setError(errorMessage);
      // Not showing a toast for get operations to avoid UI clutter
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Delete notes for a stop
  const deleteStopNotes = useCallback(async (stopId) => {
    setLoading(true);
    setError(null);
    try {
      console.log(`Deleting notes for stop ${stopId}...`);
      const response = await axios.delete(`/notes/stops/${stopId}`);
      
      if (response.data || response.status === 204) {
        console.log(`Notes deleted for stop ${stopId}`);
        toast({
          title: 'Success',
          description: 'Notes deleted successfully',
        });
        return true;
      }
      return false;
    } catch (err) {
      console.error(`Error deleting notes for stop ${stopId}:`, err);
      const errorMessage = 
        err.response?.data?.error || 
        err.message || 
        'Failed to delete notes.';
      setError(errorMessage);
      toast({
        title: 'Error',
        description: errorMessage,
        variant: 'destructive',
      });
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    updateStopNotes,
    getStopNotes,
    deleteStopNotes
  };
} 